<template>
  <div
    class="map-marker price marker-prices-list"
    :class="{ 'marker-prices-list--preview-opened': isHover }"
    :style="style"
    @click.prevent.stop="onClick"
    @mouseenter="mouseOver"
    @mouseleave="mouseOut"
  >
    <div class="marker-prices-list">
      <div class="marker-prices-list__block">
        <ul>
          <li>
            {{ priceWithCurrency() }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import eventBus from '@tools/event-bus';
import { currencyNoDecimal } from '@elements/number-formatter';
import { SelectionItemEvent } from '@enums/event';

const hoverHighlightedClass = 'selection-item-element--hover-highlighted';

export default {
  data() {
    return {
      // The point coords (in pixels) of the gps coords within the div containing the map
      basePoint: {
        x: 0,
        y: 0,
      },
      isHover: false,
      // This is used to offset the div relatively from its basePoint so the point at middle of bottom
      style: {
        bottom: 0,
        left: 0,
      },
    };
  },
  computed: {
    price() {
      return this.$options.marker.price;
    },
    selectionItemId() {
      return this.$options.marker.selectionItemId;
    },
  },
  mounted() {
    eventBus.addEventListener(SelectionItemEvent.LIST_HOVER, (event) => {
      const { selectionItemId, isHover } = event.detail;
      if (selectionItemId === this.selectionItemId) {
        this.fakeHover(isHover);
      }
    });
  },
  methods: {
    priceWithCurrency() {
      return currencyNoDecimal(this.price);
    },
    /**
     * Update the top left style property relatively from basePoint so the div is centered over the basePoint.
     */
    async updatePosition() {
      const { x = 0, y = 0 } = this.basePoint;
      const bottom = Math.round(((y * 10000) / 10000) * -1);
      const left = Math.round((x * 10000) / 10000);
      await this.$nextTick();
      this.style.left = `${left}px`;
      this.style.bottom = `${bottom}px`;
    },
    /**
     * Called when the map is dragged, zoomed, etc.
     */
    setBasePoint(point) {
      this.basePoint = point;
      this.updatePosition();
    },
    onClick() {
      eventBus.dispatchEvent(new CustomEvent(SelectionItemEvent.SCROLL_TO, { detail: this.selectionItemId }));
    },
    mouseOver() {
      this.updatePosition();
      const proposalItemElement = document.querySelector(`#selection-item-${this.selectionItemId}`);

      if (proposalItemElement) {
        proposalItemElement.classList.add(hoverHighlightedClass);
      }
    },
    mouseOut() {
      this.updatePosition();
      const proposalItemElement = document.querySelector(`#selection-item-${this.selectionItemId}`);

      if (proposalItemElement) {
        proposalItemElement.classList.remove(hoverHighlightedClass);
      }
    },
    fakeHover(isHover) {
      this.isHover = isHover;
    },
  },
};
</script>
